import {
  circleSvg,
  circleBackgroundSvg,
  AssetSvg,
  WishesSvg,
  DocumentSvg,
  dashboardCircle,
  dashboardAsset,
  dashboardBgAsset,
  dashboardWishes,
  estatePlanWishes,
  estatePlanAssetBg,
  estatePlanAssetDollarBg,
  estatePlanDoc,
  estateCircle,
  estateAsset,
  estateWishes,
  estateDoc,
  estatePlanCircle,
} from "./commonSvg";
import circleVideo from "../assets/images/circle-video.png";
import assetVideo from "../assets/images/asset-video.png";
import wishesVideo from "../assets/images/wishes-video.png";
import documentVideo from "../assets/images/document-video.png";
import { ROUTE_PATHS } from "@/router/constants";

export const notificationLabels = {
  updateRecipientContact: "Update recipient contact",
  callToAction: "Call to Action",
  goToMyRoles: "Go to My Roles",
  headerTitle: "Notifications",
  inviteAccepted: "Invite Accepted",
  receivedNewRole: "You received a new Role Request",
  inviteAcceptedToRole: (name, role) =>
    `<span class='font-[600] '>${name}</span> accepted to be your <span class='font-[600] '>${role}</span>.`,
  invitedToRole: (name, role) =>
    `<span class='font-[600] '>${name}</span> invited you to be your <span class='font-[600] '>${role}</span>.`,
  filters: {
    all: "All",
    system: "System Notifications",
    request: "Requests",
    response: "Responses",
    alert: "Alerts",
    billing: "Billing",
  },
  ariaLabels: {
    container: "Notifications container",
    list: "Notifications list",
    sort: "Sort notifications",
    icon: "Notification icon",
  },
};

export const funeralPlansLabels = {
  headerTitle: "Funeral plan direction",
  subtitle: `Designate <span class='font-500 text-deepSky'> any preferences </span> you have for your own funeral`,
  learnMoreText: "Learn more about Funeral plan direction",
  chooseYourBeneficiary: `Choose one of your <span class='font-[600]'> beneficiaries </span>`,
  shareWithBeneficiary: "Share with Beneficiary",
  releaseTimeTitle:
    "Decide when your authenticated account agents should receive this record.",
  releaseTimeLabel: "Release timing",
  selectBeneficiary: `Select any  <span class='font-[600] text-deepSky'> Beneficiary </span>`,
};

export const legalTabLabels = {
  privacy: "Privacy",
  terms: "Terms",
  header: "Terms, privacy and legal terms",
};

export const bodyHandlingLabels = {
  headerTitle: "Body handling instructions",
  subtitle: `Designate <span class='font-500 text-deepSky'> any preferences </span> you have for the handling of your remains after your gone`,
  learnMoreText: "Learn more about Body handling instructions",
  chooseYourBeneficiary: `Choose one of your <span class='font-[600]'> beneficiaries </span>`,
  shareWithBeneficiary: "Share with Beneficiary",
  releaseTimeTitle:
    "Decide when your authenticated account agents should receive this record.",
  releaseTimeLabel: "Release timing",
  bodyHandlingPreferences: "Body handling preferences",
  bodyHandlingLabel: "Body handling",
  religiousRitesLabel: "Religious Rites",
  finalRestingPlaceLabel: "Final resting place",
  finalRestingLocationLabel: "Final resting location",
  cemeteryLabel: "Cemetery",
  graveDetails: "Grave details",
  lotLabel: "Lot#",
  sectionLetterLabel: "Section/Letter",
  graveLabel: "Grave#",
  additionalInstructionsSubtitle:
    "This space is provided for you to add any direction or notes to those who will attend to your final arrangements",
  selectBeneficiary: `Select an  <span class='font-[600] text-deepSky'> Beneficiary </span>`,
  chooseBeneficiary:
    "Choose a <span class='font-[600] text-deepSky'> beneficiary </span>",
};

export const profileLabels = {
  confirmSubscriptionBtn: "Subscribe",
  confirmSubscriptionSubtitle: "",
  confirmSubscriptionTitle:
    "Please confirm your plan subscription by clicking on Subscribe.",
  usedStorage: "Used",
  inviteSentSuccessTitle: "Invitation sent successfully",
  inviteSentSuccessSubtitle:
    "You will be able to see if the user has accepted on this page",
  resetPlanSuccessTitle: "Your account was successfully reset",
  resetPlanSuccessSubtitle:
    "All your previous data has been erased, and your account is now restored to default state.",
  deleteAccountSuccessTitle: "Your Account has been Deleted",
  deleteAccountSuccessSubtitle:
    "Feel free to get back and create an account again, anytime.",
  removeFromPlanBtn: "Yes",
  removeFromPlanSubtitle:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
  removeFromPlanTitle:
    "Are you sure you want to remove this person from the plan?",
  resetPlanBtn: "Reset my plan",
  resetPlanSubtitle: "No undo actions. All your data will be lost",
  resetPlanTitle: "Are you sure you want to reset your plan?",
  deleteAccountBtn: "Delete Account",
  deleteAccountSubtitle:
    "This action is permanent and will erase all your data and you will not be able to recover your account once deleted.",
  deleteAccountTitle: "Are you sure you want to delete your account?",
  title: "View and edit your information",
  header: "My Profile",
  memberSince: "Member Since",
  personalInformationTab: "Personal Information",
  subscriptionTab: "Subscription",
  settingsPreferencesTab: "Settings & Preferences",
  legalTab: "Legal",
  saveBtnText: "Save Changes",
  im: "I'm",
  storageUsage: "Storage Usage",
  storageUsageValue: "MB Used",
};
export const inviteMemberProfileLabels = {
  fullName: "Name",
  mobileNumber: "Phone Number",
  email: "Email",
  inviteMember: "Invite member",
  inviteNewMember:
    "Inviting a new member will grant them permission to <span class='font-semibold'>create their own estate plan</span>. You can remove them at any time.",
  invitation: "Fill in the fields below to send the invitation.",
};

export const settingsProfileLabels = {
  coolOffPeriodTip:
    "Once your death or incapacitation has been registered, how long would you like sensitive information to be kept from your agent?  During this time, we will reach out to you on your mobile and email in case the registration was triggered in error.",
  userAccountStateTip:
    "This field reflects your current status in the Lved platform, and has implications on the data that is made available to your circle. It is set by your agent if anything should happen to you and reset by you upon login.",
  contactLabel: "How would you prefer to be contacted by Lved?",
  coolOffPeriod: "Cooling Off Period",
  userAccountState: "Registered Account Estate",
  settings: "Settings",
  resetMyPlan: "Reset My Plan",
  deleteAccount: "Delete Account",
};

export const subscriptionProfileLabels = {
  noActiveSubscription: "No active subscription",
  confirmCancelSubscriptionTitle: "Are you sure you want to cancel your renew?",
  extendPlanTip:
    "You family plan entitles you to invite up to three users to take advantage of your subscription. Each invitee will have their own storage; they cannot access your plan without your permission.",
  overview: "Overview",
  whatsInclude: "What's included",
  planSubscription: (plan) =>
    `<span class="font-[600]">${plan} </span> Plan Subscription `,
  billedTerm: (term) => `Billed ${term}`,
  sponsorByLVED: `Sponsor by `,
  cancelSubscription: "Cancel Subscription",
  selectYourPlan: "Select your plan",
  extendYourEstatePlanTo: `You can extend your estate plan to <span class="font-[600] text-deepSky"> one people </span>`,
  inviteMember: "Invite member",
  tapToInvite: "Tap to Invite",
  upgradePlan: "Upgrade your plan",
  subscriptionSuccessTitle: "Subscription Activated!",
  subscriptionSuccessSubtitle:
    "Your subscription has been successfully activated. You now have access to subscribed features.",
  cancelSubscriptionSuccessTitle: "Subscription Cancelled!",
  cancelSubscriptionSuccessSubtitle:
    "Your plan will end after the current billing period. Don’t worry - you’ll still have full access until that date.",
};

export const personalInfoProfileLabels = {
  givenName: "Given Name",
  surname: "Surname",
  dateOfBirth: "Date of Birth",
  address1: "Street 1",
  address2: "Street 2",
  residenceCounty: "County of Residence",
  zipCode: "Zip Code",
  state: "State",
  timeZone: "Time Zone",
  city: "City",
  maritalStatus: "Marital Status",
  mobileNumber: "Phone Number",
  redirectingToProfile: "Redirecting to Profile",
  redirectingToProfileDesc: "You’re being redirected to the profile to review your details before exploring plans.",
};

export const forgotPasswordLabels = {
  findYour: "Find your",
  account: "Account",
  enterEmail:
    "Enter the e-mail associated with your account to change your password",
  findAccount: "Find Account",
  emailLabel: "Enter your email address",
  resendEmail: "Resend Email",
  validateCode: "Validate code",
  validateCodeDescription:
    "We have sent you a 6-digit code. Check your email and enter the digits here.",
  confirmYour: "Now, let's confirm your",
  sentEmail: "We sent a confirmation email to",
  exampleEmail: "exam***@exam**.com",
  almostThere: "We're almost there!",
  emailConfirmedSuccessfully: "Email confirmed successfully",
  passwordChangedSuccessfully: "Password changed successfully", // NOSONAR javascript:S2068 - UI message label, not a credential
  directingYouToCreateNewPassword:
    "We're directing you to create a new password", // NOSONAR - UI message, not a credential
  noAccount: "don't have an account?",
  login: "Login",
  forgotPassword: "Forgot password", // NOSONAR - UI message, not a credential
  signIn: "Sign In",
  loginTitle: "Login to your",
  loginProgressTitle: "Logged in successfully",
  enterNewPassword: "Enter a new password", // NOSONAR - UI message, not a credential
  confirmPassword: "Confirm your password", // NOSONAR - UI message, not a credential
  choosePassword: "Choose a new password", // NOSONAR - UI message, not a credential
  changeYourPassword: "Change your password", // NOSONAR - UI message, not a credential
  OtpMessage: "If you haven't received the OTP, please try again.",
};

export const signUpLabels = {
  createAcc: "First, let's create your",
  password: "Password", // NOSONAR - UI message, not a credential
  firstname: "First Name",
  lastname: "Last Name",
  maritalStatus: "Marital Status",
  street1: "Street 1",
  street2: "Street 2",
  zipCode: "Zip Code",
  state: "State",
  birthDate: "Birthdate",
  city: "City",
  phone: "Phone number",
  wantToKnowProduct: "I just want to know the product",
  signUp: "Sign Up",
  directingYouToLogin: "We're directing you to Login",
  email: "Email",
  confirmEmail: "Confirm your email address",
  alreadyHaveAnAccount: "Already have an account?",
  preparingDashboard: "We're preparing your dashboard",
  quickQuestion: "In the meantime, let's ask you a few quick questions.",
  yourSelf: "Tell us a little about yourself",
  addressForm: "Let's fill your address",
};
export const layoutLabels = {
  keepYour: "Keep your",
  legacy: "legacy",
  withinReach: "within reach",
  needHelp: "Need some help?",
  chatWithUs: "Chat with us",
  faq: "FAQ",
  hello: "Hello, ",
  guest: "Guest",
  menu: "Menu",
  tourGuideDashboard:
    "This is where <span class='font-semibold'> you create and edit your estate plan</span> deciding who’s included, what’s covered, and when things happen. Add the information and make the choices that will shape your plan.",
  tourGuideBottomNavbar:
    "Use the bottom navigation bar to access different sections of the app",
  tourGuideSidebar:
    "This tab contains your <span class='font-semibold'>estate plan sections, organized by topic</span> so you can easily find and access your information.",
  tourGuideNavigationBar:
    "This is your navigation bar, giving you access to your profile, settings, notifications, and a search function to quickly find what you need.",
  tourGuideRightPanel:
    "And finally, this is your menu. Use it to quickly access other sections of the site.",
  footerTitle: "What would you like to do next?",
  youHaveBeenInvitedBy: (name) =>
    `You have been invited by <span class="!font-[600] capitalize"> ${name} </span> to be part of his/her LVED plan`,
  guideThroughAgent: "We will guide you through creating your agent account",
  privacyPolicy: "LVED’s Terms of service and Privacy policy",
};

export const subscriptionLabels = {
  plans: "Our Plans",
  choosePlan: "Choose the plan",
  planChoose: "Choose Plan",
  redeemGiftCard: "Redeem Gift Card",
  fits: "that fits you",
  option:
    "Select the best option to secure your legacy and keep everything in one place.",
  mostPopular: "MOST POPULAR",
  year: "/year",
  estatePlan: "Estate Plan",
  webQueries: "For most businesses that want to optimize web queries",
  insertYour: "Insert your",
  promoCode: "Promo Code",
  success: "Code applied successfully",
  discount: "You can come back and choose your plan with discount",
  yourBeneficiary: "Your beneficiary has been",
  successfullyAdded: " successfully added",
  youCan: "You can come back and add more whenever you need",
  wouldLike: "Would like to authenticate your agent now?",
  weRedirect: "We’ll redirect you",
  upgradeMessage: "To upgrade your plan, please visit",
  supportLink: "www.LVED.support.com",
  contactUs: "Contact us",
  email: "Email",
  emailId: "support@lved.com",
  phone: "Phone",
  phoneNumber: "+1 (877) 440-LVED (5833)",
  invalidPromoCode: "Invalid promo code"
};

export const welcomeLabels = {
  steps:
    "Your story deserves to continue—with clarity, care, and peace. We’ll guide you step by step.",
  tour: "Take a tour",
  bureaucracy: "15,000 hours per year saved by wasting time on bureaucracy",
  message: "Don't show this message again",
  explore: "Explore our plans",
  later: "Maybe Later",
  title: "Welcome ",
  youHere: "you here, ",
  thinking: "to LVED, and thank you for being here.",
};

export const digitalVaultLabels = {
  details: "Details",
  digitalVault: "Digital Vault",
  open: "Open",
  description:
    "Securely store your important files, legal documents, and preferences, ensuring easy access when needed.",
  noItems: "No Items Added",
  Keep: "Keep and manage",
  data: "all your data",
  documents: " documents",
  choice: "and choices",
  safe: " safe in one place",
  close: "Close",
  dontknow: "I Don't know",
  title: "Which kind of item do you want to create?",
  title2: "Now, Choose a Category",
  addAccount: "Add your Bank account",
  generalInfo: "General information",
  credentials: "Credentials",
  wouldYou: "Would you like to",
  relate: "relate this item",
  withAny: " with any",
  beneficiary: "beneficiary",
  hideAgent: "Hide from my agent",
  youCan: "You can",
  choose: "choose",
  an: "an",
  existingBeneficiary: "existing beneficiary",
  by: "by",
  tapping: "tapping on these card",
  chooseAnExisting: "Choose an existing beneficiary.",
  statement1:
    "You can change, remove or disable this feature whenever you want, by tapping on the card.",
  others: "Others",
  yourItems: "Your item has been",
  successfullyCreated: "successfully created",
  more: "You can come back and add more whenever you need",
  addMore: "Add More Items for your Digital Vault",
  later: "Maybe Later",
  goodThinkingTitle: "It's good to see you here, thinking of you.",
  beneficiaryInfo:
    "Select Yes if you'd like to indicate who should be given this item upon your passing or incapacitation",
  itemCreated: `Your item has been <span class='font-just font-[600]' >successfully created</span>`,
  view: "Viewing",
  viewDigitalVault: "You can view the digital vault of",
  vault: "'s Vault",
};
export const commonLabels = {
  yesText: "Yes",
  noNewNotifications: "No new notifications",
  chooseExistingBeneficiary:
    "Choose an existing <span class='font-[600] text-deepSky'> beneficiary </span>",
  noDataFound: "No Data Found.",
  accountAgent: "Account Agent",
  spouse: "Spouse",
  children: "Children",
  changeBeneficiary: "Change Beneficiary",
  selectBeneficiary: "Select Beneficiary",
  sendInviteAgain: "Send Invite Again",
  changePrincipalAgent: "Change Principal Agent",
  changeCoPrincipalAgent: "Change Co-Principal Agent",
  changeBackupAgent: "Change Backup Agent",
  changePrincipalExecutor: "Change Principal Executor",
  changeCoPrincipalExecutor: "Change Co-Principal Executor",
  changeBackupExecutor: "Change Backup Executor",
  changePrincipalTrustee: "Change Principal Trustee",
  changeCoPrincipalTrustee: "Change Co-Principal Trustee",
  changeBackupTrustee: "Change Backup Trustee",
  changePrincipalGuardian: "Change Principal Guardian",
  changeCoPrincipalGuardian: "Change Co-Principal Guardian",
  changeBackupGuardian: "Change Backup Guardian",
  remove: "Remove",
  sortBy: "Sort By",
  from: "From",
  new: "New",
  older: "Older",
  decline: "Decline",
  message: "Message",
  acceptRequest: "Accept Request",
  tryAgain: "Try Again",
  additionalInstructionsTitle: "Additional instructions",
  additionalInstructionsLabel: "Additional instructions",
  optional: "Optional",
  tapToChoose: "Tap to Choose",
  tapToSelectBeneficiary: `Tap to Select <span class='font-[600] text-deepSky'>beneficiary</span>`,
  addNew: "Add New",
  createNew: `Or, you can <span class='font-[600] text-deepSky'>create a new one</span>`,
  selected: "Selected",
  tapToSelect: "Tap to Select",
  cancel: "Cancel",
  next: "Next",
  search: "Search",
  skipForNow: "Skip for now",
  confirmPassword: "Confirm password",
  newPassword: "New password",
  back: "Back",
  done: "Done",
  exit: "Exit",
  edit: "Edit",
  add: "Add",
  tapToCreate: "Tap to create",
  createEstatePlan:
    "Here, your estate plan is built with clarity, care, and security.",
  changePassword: "Change your password",
  searchResult: "No results found for",
  searchKeyword: "Try searching with different keywords",
  wellDone: "Well done!",
  stepCompleted: "Step completed",
  areYouSure: "Are you sure?",
  no: "No, Cancel",
  yes: "Yes, Delete",
  areYouSureRemoveRecipient: "Are you sure you want to remove this recipient?",
  NotFound: "404 - Page Not Found",
  pageNotFound: "The page you're looking for doesn't exist.",
  goToDashboard: "Go to Dashboard",
  enterPassphrase: "Create your passphrase",
  forbidden: "403 - Forbidden",
  forbiddenPage: "You do not have permission to view this page.",
  recentlyAdded: "Recently Added",
  goToDigitalVault: "Go to Digital Vault",
  recentActivity: "Recent Activities",
  complete: "% Complete",
  goToDocument: "Go to My Documents",
  goToMyEstatePlan: "Go to My Estate Plan",
  goToLegacy: "Go to Legacy",
  go: "Go",
  playPause: "Play/Pause",
  thumbnail: "thumbnail",
  legacyItem: "Legacy item",
  untitledStory: "Untitled Story",
  untitledMessage: "Untitled Message",
  failedToLoadVideo: "Failed to load video.",
  pleaseTryAgain: "Please try again.",
  okay: "Okay",
  close: "Close",
  avatar: "Avatar",
  showTourGuide: "Show tour guide",
  upgradePlan: "Upgrade Plan",
  details: "Details",
  story: "Story",
  privateMessage: "Private Message",
  submit: "Submit",
};

export const userIncapacitationReportLabels = {
  UserIncapacitationReport: "User Incapacitation Report",
  reportedUserFirstName: "Reported User's First Name",
  reportedUserLastName: "Reported User's Last Name",
  reportedUserEmail: "Reported User's Email",
  reportedUserPhone: "Reported User's Phone Number",
  reportedDate: "Reported Date",
  reportedStatus: "Reported Status",
  additionalNotes: "Additional Notes",
  incapacitationCode: "Incapacitation Code",
  UserIncapacitation: "Register Incapacitation",
};

export const tutorialLabels = {
  story: "Your story",
  matters: "matters",
  planStepBystep:
    "Let us guide you through building your estate plan, step by step",
  step: "Step 0",
  watchvideo: "Watch this little video",
  watchSubtitle:
    "Watch the videos above to discover how we make creating your plan simple and clear.",
  desc: "These tutorials walk you through each step—adding loved ones, organizing your assets, setting your wishes, and generating legal documents. We explain everything in plain language so you’ll always know what to do next. Follow along at your own pace and feel confident that your plan is built with clarity and care.",
  module: "What is",
  questionMark: "?",
  watchVideoTips: "Watch this little video tips",
  takeTour: "Take a Tour",
  see: "See",
  how: "How",
  Lved: "Lved",
  Works: "Works",
  explorePlan: "Explore our plans and get",
  startedToday: "started today",
};

export const estateSectionLabels = {
  back: "Back to",
  myEstatePlan: "My Estate Plan",
  choose: "choose",
  anyPart: "any part",
  to: "to",
  manage: "manage and edit this section",
  yourPlan: "of your plan",
  sort: "Sort By",
  status: "Status",
  circle: "Circle",
  goToAssets: "Go to Assets",
  planDocuments: "Plan Documents",
  wishes: "Wishes",
  goToPlanDocuments: "Go to Plan Documents",
  goToWishes: "Go to Wishes",
  assets: "Assets",
};

export const estatePlanLabels = {
  managePlan: "Manage Your Estate Plan",
  startPlan: "Start My Plan Now",
  estatePlanManageLabel: "Manage your plan and keep it",
  updated: "updated",
  subDesc: "Add more items, adjust, create, anytime",
  tapToEdit: "Click to Edit",
  estateLabel: "Keep building your plan and feel more",
  secure: "secure",
  estateRestLabel: "planning the details of your life",
  planCreation: "Plan creation progress",
  doingGreat: "You're doing great! Keep going and finish up",
  ContinueBuilding: "Continue building your plan",
  buildingPlan: "Building Your Estate Plan",
  skip: "Skip to",
  beneficiaries: "Beneficiaries",
  nominateAndDesignated: "Nominate & Designate",
  letUsBuildingPlan: "To get started, share your information",
  letSetUpYour: "Let's set up your",
  bequestsEtc: `cash bequests, assets bequests, remainder distribution, disinheritance, trusts <span class="font-400 text-darkBlue">, and more</span>`,
  byGetting: "and add the",
  peopleAround: "the people who matter most",
  firstStep:
    "This step allows you to add beneficiaries and adjust your preferences.",
  wishesFirstStep:
    "In this step, you’ll distribute specific amounts, assets, and wishes to your chosen beneficiaries.",
  beginOnboarding: "Start Onboarding",
  skipStep: "Skip this step",
  savingProgress: "Saving Progress",
  circle: "Circle",
  step1: "Step 1",
  step2: "Step 2",
  step3: "Step 3",
  assets: "Assets",
  wishes: "Wishes",
  moveOn: "Now, let's move on and",
  addYour: "add your",
  updateYourPlan: "You can come back to this step anytime and update your plan",
  tapToAdd: "Tap to Start",
  addLater: "Add Later",
  your: "your",
  settingsAndPreferences: "Settings & Preferences",
  important: "Important",
  nominate: "Nominate & Designate",
  nameYour: "Now, let's name your",
  agent: "agents, executors,trustees and guardians",
  carry: "who will carry out your plan after life",
  feelFreeToReturn: "You can return to this step anytime to update your plan",
  nominateCircle: "Nominate my Circle",
  setYour: "Set your",
  attorney: "preferences, assign power of attorneys,",
  and: "and",
  configureKeyDetails: "configure key details",
  beneficiariesFor: "for your beneficiaries",
  setYourPreferencesBtn: "Set your Preferences",
  specifyAny: "Specify the",
  beneficiariesSmall: "beneficiaries",
  includeEstatePlan: "you’d like to include in your estate plan.",
  learnMore: "Learn more about Beneficiaries",
  chooseBeneficiary: "Choose the type of beneficiary you want to add.",
  nextStep: "Next Step",
  healthPower: "Health power of attorney",
  learnMoreHealthPower: "Learn more about Health Power of Attorney",
  selectYour: "Select Your",
  principalPower: "principal health power of attorney",
  nominateHealth: "Nominate & Designate",
  healthCare: "health care",
  shouldIncapacitated: "should you become incapacitated",
  backupHealth: "backup health power of attorney",
  preferences: "Preferences",
  healthPowerGranted: "Health powers granted",
  healthPowerDesc:
    "Your agent(s) must act in accordance with your wishes outlined in your living will. In addition:",
  healthPowerLimit: "Health power limits",
  healthPowerLimitDesc:
    "Describe any limitations you’d like to place on your granting health power of attorney",
  lifeSupportDirective: "Life Support Directives",
  lifeSupport: "Life support",
  lifeSupportDesc:
    "If you should become incapacitated and two physicians indicate that you",
  lifeSupportSubTitle: [
    "Have an incurable condition that will result in your death within a short time",
    "Are in an irreversible coma",
    "Are in a persistent vegetative state",
  ],
  organDonation: "Organ donation",
  organDonationDesc:
    "This section below captures your wishes, after your passing, concerning your potentially life saving organs.",
  additionalInstruction: "Additional instructions",
  additionalDesc:
    "Use this field to provide any specific instructions or preferences regarding life support and organ donation",
  healthSupport: "Health Support",
  designate: "Designate who you",
  medicalInfo: "would like to be given access to your medical information",
  learnHealthSupport: "Learn more about Health Support",
  access: "Access given to:",
  scopeOfRelease: "Scope of release",
  informationIncapacitation: "Include information related to my incapacitation",
  excludeMedical: "Excluded medical information",
  categoryInfoExclude: "Please enter the category of information to exclude",
  durability: "Durability of this HIPAA release",
  financialPOA: "Financial power of attorney",
  nominateWhoYouWouldLike: "Nominate who you would like",
  makeDecisions: "make decisions",
  regardingEstatePlan: "regarding your estate should you become incapacitated",
  learnFinancialSupport: "Learn more about Financial Power of Attorney",
  selectYourPrincipal: "Select your principal",
  selectYourBackup: "Select your backup",
  financialPower: "financial power of attorney",
  grantPower: "Grant Power",
  selectPower: "Select which powers you’d like to give while incapacitated",
  additionalPower: "Additional powers granted",
  enterCategoryPower: "Please enter the category of powers to grant.",
  limitationExercise: "Limitations to exercise power-of-attorney",
  enterCategory: "Please enter the category of powers to limit.",
  otherPower: "Other power of attorney designations",
  learnAsset: "Learn more about Asset",
  chooseAsset: "Choose here the type of asset you want to add",
  createYour: "Now, let's create your",
  setYourPreferences: `wishlist. <span class="font-[600]">Set your preferences</span>`,
  whenYouPassAway: "when you pass away.",
  onboardingProgress: "Well done!",
  helpUsGetToKnowYouBetter: "Step completed",
  documents: "Documents",
  beneficiaryTooltipText:
    "Beneficiaries are the persons or entities designated to receive life insurance benefits or resources upon the death of the policyholder. They can be family members, charities, or anyone chosen to receive the insurance claim.",
  handleRemains: "May they decide how to handle your remains",
  assetTooltipText:
    "Assets are any physical or digital item that has value or significance and you'd like to pass on when the time is right.  It can includes your home, bank accounts, or even knickknacks around your home with sentimental value.  Use this section to catalog your assets for an organized handoff.",
  autoPsy: "May they consent to an autopsy",
  limitation: "Limitation",
  healthPOATooltip:
    "A health care power of attorney is a legal document that authorizes someone you trust to make medical decisions on your behalf if you’re unable to do so.",
  healthSupportTooltip:
    "A Health Care POA is specifically tailored for making medical decisions while a financial POA is much broader in scope - it’s not just about your health; it lets someone handle your financial affairs.",
  incapacitate: "Only during my incapacitation",
  exclude: "Exclude",
  alcohol: "Also include information about substance/alcohol abuse",
  mentalHealth: "Also include information about mental health treatment",
  HIV: "Also include information about HIV/AIDS and STD treatment",
  power: "Power",
  gift: "May make gifts in excess of your state’s limits",
  personalGain:
    "May realize personal gain as a result of acting on your behalf",
  outOfPocket:
    "Should your designee’s compensation be limited to out-of-pocket expenses only?",
  guardians:
    "Would you like to nominate your designee as your guardian should a court determine you require one?",
  addressLabel: "Select this option if this individual lives with you",
  healthSupportDesc: `Designate who you <span class='text-deepSky font-[600]'>would like to be given access to your medical information</span> should you become incapacitated`,
  executorOtherDesc:
    "As an executor, you are responsible for handling the affairs of the deceased according to the plan set out in the will, including distributing assets and paying debts.",
  trusteeOtherDesc:
    "As a trustee, you are responsible for managing and distributing trust assets according to the trust terms for the benefit of the beneficiaries.",
  guardianOtherDesc:
    "As a guardian, you are responsible for making personal and medical decisions for minor children or incapacitated adults if the primary caregiver cannot.",
  healthPowerOfAttorneyDesc:
    "As holder of health power of attorney, you are responsible for making medical decisions on behalf of the principal if they become unable to do so themselves.",
  financialPowerOfAttorneyDesc:
    " As holder of financial power of attorney, you are responsible for managing the principal's financial affairs and assets if they become incapacitated.",
  HIPPAReleaseAuthorizationRecipientDesc:
    "As someone receiving HIPAA release authorization, you are able to access the principal's protected health information to make informed decisions when authorized.",
};

export const trusteeLabels = {
  learnMoreTextTip:
    "If the designated individual accepts this role, she is bound to follow the instructions within the Trust and if required to use discretion, should exercise due care looking toward the best interests of the beneficiary(ies) of the Trust.",
  trusteeAddedSuccessTitle: "Your request has been submitted successfully",
  trusteeAddedSuccessSubtitle:
    "You will be notified when your trustees approves it",
  selectPersonPrincipalTrustee: `Select a person to be your <span class='font-[600]'> Principal Trustee </span>`,
  selectPersonCoPrincipalTrustee: `Select a person to be your <span class='font-[600]'> Co-Principal Trustee </span>`,
  selectPersonBackupTrustee: `Select a person to be your <span class='font-[600]'> Backup Trustee </span>`,
  sendRequestPersonPrincipalTrustee: `Send request to your <span class='font-[600]'> Principal Trustee </span>`,
  sendRequestPersonCoPrincipalTrustee: `Send request to your <span class='font-[600]'> Co-Principal Trustee </span>`,
  sendRequestPersonBackupTrustee: `Send request to your <span class='font-[600]'> Backup Trustee </span>`,
  sendRequestPersonSubtitle: `You can <span class='font-[600] text-deepSky'> customize </span>your request for your chosen <span class='font-[600]'> trustee </span>`,
  selectTrusteeBtn: "Select Principle Trustee",
  sendRequestPersonSaveBtn: "Save and Send Request",
  headerTitle: "Trustee",
  subtitle: `Nominate who you would like to act as <span class='font-[600] text-deepSky'> trustee </span> for your dependents’ trust `,
  selectYourPrincipalTrustee:
    "Select your <span class='font-[600]'> Principal trustees </span>",
  addPrincipleTrustee: "Add Principal Trustee",
  addCoPrincipleTrustee: "Add Co-Principle Trustee",
  addBackupTrustee: "Add Backup Trustee",
  learnMoreText: "Learn more about Dependents trustees",
  selectYourBackupTrustee:
    "Select your <span class='font-[600]'> Backup trustees </span>",
  createPrincipleTrusteeTitle:
    "Create a new <span class='font-[600]'> Principle Trustee </span>",
  createCoPrincipleTrusteeTitle:
    "Create a new <span class='font-[600]'> Co-Principle Trustee </span>",
  createBackupTrusteeTitle:
    "Create a new <span class='font-[600]'> Backup Trustee </span>",
};

export const petTrustLabel = {
  learnMoreTextTip:
    "A LVED pet trust holds money for the care of the specific pets you designate. These funds can be used by the pets’ guardians to care for your pets.",
  deleteAccountBtn: "Yes, Delete",
  deleteAccountNoBtn: "No, Cancel",
  deleteAccountSubtitle: "This action can’t be undone.",
  deleteAccountTitle: "Are you sure you want to delete this pet trust?",
  selectAddPetTrustTitle:
    "Select a pet to add to this <span class='font-[600]'> Trust </span>",
  createPetTrustTitle: "Create your <span class='font-[600]'>Pet Trust </span>",
  createPetSubtitle: "First, choose a name for this pet trust",
  petTrustName: "Pet trust name",
  headerTitle: "Pet trusts",
  subtitle: `Direct assets toward the care of your <span class='font-500 text-deepSky'> pets</span>.`,
  createPetTrust: "Create your <span class='font-[600]'> pet trust </span>",
  addPetTrust: "Add Pet Trust",
  addPet: "Add Pet",
  cashBequest: "Cash Bequest",
  totalBequest: "Total bequest to these pets individually: ",
  otherInfo: "Other information",
  isFormalTrust: "Is formal trust?",
  additionalAllocation: "Additional allocation to fund this trust",
  deletePetTrustBtn: "Delete Pet Trust",
  yourPetTrust: "Your <span class='font-[600]'> pet trusts </span>",
  learnMoreText: "Learn more about Pet trusts.",
  chooseExistingPet:
    "Choose an existing <span class='font-[600] text-deepSky'> pet </span> for this pet trust",
  successTitle: "Your request has been submitted successfully",
  createPetTrustBtn: "Create Pet trust",
  save: "Save",
  petSelectionRequired: "Please select at least one pet to create a pet trust",
  enterPetTrustName: "Enter pet trust name.",
};

export const dependentsTrustLabels = {
  headerTitle: "Dependents trust",
  subtitle: `You may designate when each when each beneficiary of your <span class='font-500 text-deepSky'> remaining estate should receive their inheritance</span>. Note that you may break up each inheritance by the age.`,
  learnMoreText: "Learn more about Dependents trust",
  selectBeneficiarySectionTitle:
    "Select a <span class='font-[600]'> beneficiary </span> below to designate:",
  otherBeneficiarySectionTitle: "Other beneficiaries",
  left: "Left",
  createAgeBreakup: "Create a new age inheritance break up",
  noAgeAdded: "No age added",
  save: "Save",
  slideToSetPercentage: "Slide to set percentage",
  age: "Age",
  saveBtn: "Save",
};

export const lifeSupportLabels = {
  headerTitle: "Life support directives",
  subtitle: "Set up your life support directives",
  learnMoreText: "Learn more about life support directives",
  lifeSupportSectionTitle: "Life support",
  organDonationSectionTitle: "Organ donation",
  additionalInstructionsSectionTitle: "Additional instructions",
  lifeSupportSectionQuestion:
    "If you should become incapacitated and two physicians indicate that you",
  lifeSupportSectionBullets: [
    "Have an incurable condition that will result in your death within a short time",
    "Are in an irreversible coma",
    "Are in a persistent vegetative state",
  ],
  organDonationSectionQuestion:
    "This section below captures your wishes, after your passing, concerning your potentially life saving organs.",
  additionalInstructionsSectionQuestion:
    "Use this field to provide any specific instructions or preferences regarding life support and organ donation",
  keepMeOnLifeSupport: "Keep me on life support",
  exceptionIfPregnant: "Make exception if pregnant",
  continueNutrition: "Continue to provide nutrition",
  administerPainMedication: "Administer pain medication as needed",
  wishToDonateOrgans: "Do you wish to donate any organs",
  medicalNeeds: "Medical needs",
  education: "Education",
  research: "Research",
  organDonationLimitPlaceholder:
    "If you want to limit the donation, specify which organs you wish to donate",
  additionalInstructionsPlaceholder: "Additional instructions",
  lifeSupportDesc:
    "When you no longer have the capacity to make critical medical decisions, these life support directives help communicate your preferences for care in advance",
};

export const revocableTrustLabels = {
  learnMoreTextTip:
    "A revocable trust offers flexibility and probate avoidance, turning irrevocable upon death",
  headerTitle: "Revocable trust",
  subtitle: `A revocable trust allows you to <span class='font-500 text-deepSky'> manage </span> and <span class='font-500 text-deepSky'> protect </span> your assets while maintaining flexibility.`,
  learnMoreText: "Learn more about Revocable trust",
  sectionTitle: "Trust Creation & Asset Protection",
  sectionQuestion:
    "Would you like to avoid probate by creating a revocable trust and placing your assets in it?",
  createTrust: "Create a revocable trust?",
  trustNameLabel: "Choose a name for your trust",
};

export const spousalTrustLabels = {
  headerTitle: "Spousal trust",
  subtitle: `Set up your spousal <span class='font-500 text-deepSky'> credit shelter trust </span> `,
  learnMoreText: "Learn more about Spousal trust",
  sectionTitle: "Credit shelter trust",
  sectionQuestion:
    "If, in the future, you have a spouse, and they survive you, would you like to give them the option, at the time of your passing, to place any assets you transfer that are not already in their name, into a trust?",
  includeTrust: "Include this trust option",
};

export const executorLabels = {
  learnMoreTextTip:
    "Your executor will be charged with managing and settling your estate, ensuring that everything is done according to your wishes as outlined in your will, or, if there’s no will, according to state laws.",
  executorAddedSuccessTitle: "Your request has been submitted successfully",
  executorAddedSuccessSubtitle:
    "You will be notified when your estate executor approves it",
  selectPersonPrincipalExecutor: `Select a person to be your <span class='font-[600]'> Principal Estate Executor </span>`,
  selectPersonCoPrincipalExecutor: `Select a person to be your <span class='font-[600]'> Co-Principal Estate Executor </span>`,
  selectPersonBackupExecutor: `Select a person to be your <span class='font-[600]'> Backup Estate Executor </span>`,
  sendRequestPersonPrincipalExecutor: `Send request to your <span class='font-[600]'> Principal Estate Executor </span>`,
  sendRequestPersonCoPrincipalExecutor: `Send request to your <span class='font-[600]'> Co-Principal Estate Executor </span>`,
  sendRequestPersonBackupExecutor: `Send request to your <span class='font-[600]'> Backup Estate Executor </span>`,
  sendRequestPersonSubtitle: `You can <span class='font-[600] text-deepSky'> customize </span>your request for your chosen <span class='font-[600]'> estate executor </span>`,
  selectExecutorBtn: "Select Estate Executor",
  sendRequestPersonSaveBtn: "Save and Send Request",
  headerTitle: "Estate Executor",
  subtitle: `Who would you like to nominate as <span class='font-[600] text-deepSky'> executor </span> of your estate when you’re gone? `,
  selectYourPrincipalExecutor:
    "Select your <span class='font-[600]'> Principal estate executor </span>",
  addPrincipleExecutor: "Add Principal Executor",
  addCoPrincipleExecutor: "Add Co-Principle Executor",
  addBackupExecutor: "Add Backup Executor",
  learnMoreText: "Learn more about Estate executor",
  selectYourBackupExecutor:
    "Select your <span class='font-[600]'> Backup estate executor </span>",
  createPrincipleExecutorTitle:
    "Create a new <span class='font-[600]'> Principle Executor </span>",
  createCoPrincipleExecutorTitle:
    "Create a new <span class='font-[600]'> Co-Principle Executor </span>",
  createBackupExecutorTitle:
    "Create a new <span class='font-[600]'> Backup Executor </span>",
};

export const guardianLabels = {
  learnMoreTextTip:
    "A guardian for your children is someone you choose to take over the role of parenting in case you’re no longer able to do so",
  guardianAddedSuccessTitle: "Your request has been submitted successfully",
  guardianAddedSuccessSubtitle:
    "You will be notified when your guardian approves it",
  selectPersonPrincipalGuardian: `Select a person to be your <span class='font-[600]'> Principal Children Guardian </span>`,
  selectPersonCoPrincipalGuardian: `Select a person to be your <span class='font-[600]'> Co-Principal Children Guardian </span>`,
  selectPersonBackupGuardian: `Select a person to be your <span class='font-[600]'> Backup Children Guardian </span>`,
  sendRequestPersonPrincipalGuardian: `Send request to your <span class='font-[600]'> Principal Guardian </span>`,
  sendRequestPersonCoPrincipalGuardian: `Send request to your <span class='font-[600]'> Co-Principal Guardian </span>`,
  sendRequestPersonBackupGuardian: `Send request to your <span class='font-[600]'> Backup Guardian </span>`,
  sendRequestPersonSubtitle: `You can <span class='font-[600] text-deepSky'> customize </span>your request for your chosen <span class='font-[600]'> children guardian </span>`,
  selectGuardianBtn: "Select Children Guardian",
  sendRequestPersonSaveBtn: "Save and Send Request",
  headerTitle: "Children Guardian",
  subtitle: `Nominate who you would like to act as <span class='font-[600] text-deepSky'> guardian </span> for your dependents `,
  selectYourPrincipalGuardian:
    "Select your <span class='font-[600]'> Principal Guardian </span>",
  addPrincipleGuardian: "Add Principal Guardian",
  addCoPrincipleGuardian: "Add Co-Principle Guardian",
  addBackupGuardian: "Add Backup Guardian",
  learnMoreText: "Learn more about Children Guardians",
  selectYourBackupGuardian:
    "Select your <span class='font-[600]'> Backup Guardian </span>",
  createPrincipleGuardianTitle:
    "Create a new <span class='font-[600]'> Principle Children Guardian </span>",
  createCoPrincipleGuardianTitle:
    "Create a new <span class='font-[600]'> Co-Principle Children Guardian </span>",
  createBackupGuardianTitle:
    "Create a new <span class='font-[600]'> Backup Children Guardian </span>",
};

export const setPrincipalLabels = {
  learnMoreAgentsTip:
    "Account agents are the individuals given staged access to your account upon an incapacitation event and your death. They are responsible for registering these life events when they occur and can be contacted by your family using the family letter we mail to your home.",
  createPrincipleAgentTitle:
    "Create a new <span class='font-[600]'> Principle Account Agent </span>",
  createCoPrincipleAgentTitle:
    "Create a new <span class='font-[600]'> Co-Principle Account Agent </span>",
  createBackupAgentTitle:
    "Create a new <span class='font-[600]'> Backup Account Agent </span>",
  codeAuthenticateBtn: "Input 5-Digits to Authenticate",
  maybeLater: "Maybe Later",
  codeGenerateTitle: (name) =>
    `You have accepted <span class='font-[600]'> ${name}'s </span> request.`,
  codeGenerateSubtitle: (role) =>
    `Follow the instructions to become an <span class='font-[600]'> authenticated account ${role}</span>`,
  codeGenerateInstruction: (name) =>
    `${name} will provide you with a <span class='font-[600]'> 5-digit PIN </span> to authenticate your role. After that, <span class='font-[600]'>${name} you will receive another PIN </span> and must provide it to ${name} for him to authenticate as well.`,

  generatingCodeText: `Generating Code`,
  authenticateInstruction1: (name) =>
    `You need to generate a <span class='font-[600]'> 5-digit PIN for ${name}</span>. After that, <span class='font-[600]'>${name} will generate you a 5-digit PIN </span> in return, and once it’s verified, she will become an authenticated Account Agent`,
  authenticateInstruction2: (name) =>
    `You must be live with ${name} to start the process`,
  invitingSubtitle: (name, role) =>
    `Follow the instructions to authenticate <span class='font-[600]'>${name}</span> as a <span class='font-[600]'> ${role} account agent</span>`,
  codeValidateSuccess: (name) =>
    `You have <span class='font-[600]'> validated  </span> the code provided by ${name}.`,
  shareCodeSubtitle: (name) =>
    `Now, <span class='font-[600]'> Share </span> this new code with <span class='font-[600]'> ${name} </span> so she can complete the authentication process.`,
  congrats: "Congratulations!",
  authenticateAgentSuccessSubtitle: "Now an authenticated Account Agent",
  add1stBackupAgent: "Add 1st Backup Agent",
  add2ndBackupAgent: "Add Backup Agent",
  addPrincipleAgent: "Add Principal Agent",
  subtitle: `You need to <span class='font-[600] text-deepSky'>select a Principal Agent. </span>The person who will notify LVED of a life event, which will release your plan to your beneficiaries.`,
  selectYourPrincipalAgent:
    "Select your <span class='font-[600]'> principal agent </span>",
  authenticateAgentNow: "Would like to authenticate your agent now?",
  authenticateAgentRedirect: "We'll redirected you ",
  agentAddedSuccessTitle: "Your Account agent has been successfully added",
  agentAddedSuccessSubtitle: "You can edit or add more beneficiaries anytime.",
  headerTitle: "Account agent",
  accountAgent: "Account agent",
  youNeedTo: "You need to",
  selectAnPrincipal: "select an Principal Agent",
  toExecute: "to execute and manage your plan preferences",
  selectYour: "Select your",
  principalAgent: "principal agent",
  selectAgent: "Select Account Agent",
  choose: "Tap to Choose",
  addAgent: "Add Principal Agent",
  other: "Other",
  createNewOne: "create a new one",
  selected: "Selected",
  tapToSelectBeneficiary: `Tap to Select <span class='font-[600] text-deepSky'>beneficiary</span>`,
  existing: "Choose an existing",
  sendRequestPersonSaveBtn: "Save and Send Request",
  selectPersonPrincipalAccount: `Select a person to be your <span class='font-[600]'> Principal Account Agent </span>`,
  selectPersonCoPrincipalAccount: `Select a person to be your <span class='font-[600]'> Co-Principal Account Agent </span>`,
  selectPersonBackupAccount: `Select a person to be your <span class='font-[600]'> Backup Account Agent </span>`,
  sendRequestPersonPrincipalAccount: `Send request to your <span class='font-[600]'> Principal Account Agent </span>`,
  sendRequestPersonCoPrincipalAccount: `Send request to your <span class='font-[600]'> Co-Principal Account Agent </span>`,
  sendRequestPersonBackupAccount: `Send request to your <span class='font-[600]'> Backup Account Agent </span>`,
  sendRequestPersonSubtitle: `You can <span class='font-[600] text-deepSky'> customize </span>your request for your chosen <span class='font-[600]'> account agent </span>`,
  next: "Next Step",
  createNew: `Or, you can <span class='font-[600] text-deepSky'>create a new one</span>`,
  addNew: "Add New",
  tapToCreate: "Tap to Create",
  roles: "Roles",
  learnMoreAgents: "Learn more about Agents",
  youAreInviting: (name) =>
    `You are inviting <span class='font-[600]'>${name}</span> to become your <span class='font-[600]'>Account Agent</span>`,
  shareCode: (name) =>
    `<span class='font-[600]'>Share </span> this code with <span class='font-[600]'> ${name} </span> so he/she can initiate the authentication process.`,
  enter: "Enter",
  authenticationCode: "Authentication Code",
  enter5DigitsCodeReceivedFrom: "Enter 5-digits code received from",
  codeGenerateSuccess: `Code <span class='font-[600]'> successfully </span> generated`,
  codeValidTime: (timer) =>
    `This code is valid for <span class='font-[600]'> ${timer} </span> minute`,
  generateNewCode: "Generate New Code",
  validateSubtitle: `Now, enter the code she provided to complete the <span class='font-[600]'> account agent authentication process. </span>`,
  validateSuccess: (name) =>
    `<span class='font-[600]'> ${name} </span> has <span class='font-[600]'> successfully validated </span> the code you provided.`,
  generateCode: "Generate Code",
  done: "Done",
  continue: "Continue",
};

export const legacyLabels = {
  legacy: "Legacy",
  keepYourLegacyAlive: "Keep your Legacy Alive",
  legacyLabel: `<span class='text-btnActive font-normal'> Save your </span> <span class='text-deepSky font-semibold'> memories </span> <span class='text-btnActive font-normal'> and </span> <span class='text-deepSky font-semibold'> wishes </span> <span class='text-btnActive font-normal'>for those who matter</span>`,
  memories: "memories",
  wishes: "wishes",
  for: "for",
  forThose: "those who matter",
  createPersonalVideo:
    "Create personal videos for the future or share your life's story with others.",
  stories: "Stories",
  addStorySuggestion:
    "You can add your story or use one of our suggestions - stories are shared with everyone at your stories link",
  addPrivateMessageSuggestion:
    "Add a new private message (use one of our suggestions if you're stuck)",
  privateMessages: "Private Messages",
  hideSuggestion: "Hide Suggestion",
  showSuggestion: "Show Suggestion",
  createNewMessage: "Create a new message",
  whichMessage: "Which message would you like to create?",
  chooseOptions: "Choose from the options below",
  createPrivateMessage: "Create a new private message",
  uploadVideo: "Upload Video",
  recordVideoFromYourDevice: "Record a video from your device",
  chooseHowToSendVideo: "Choose how you want to send your video",
  createNewStory: "Create a new story",
  recordingTip: "Here are some tips for recording your video",
  createEdit: "Create, edit and save in your Legacy",
  suggestions: "Suggestions",
  createStory: "Create an story using this tip",
  memory: "What memory about your childhood you like most?",
  bigAccomplishment: "What was a big accomplishment for you?",
  schoolExperience: "What school experiences you remember?",
  spouseMessage: "Leave a message to your spouse",
  grandChildMessage: "Leave a message for your future grand kids",
  childHoodFriendMessage: "Create messages for your childhood best friend",
  releaseTimePeriod: "Release timing period",
  recordStory: "Record Story",
  recordPrivateMessage: "Record Private Message",
  chooseTitleOfYourStory: "Choose a title for your story",
  chooseTitleOfYourPrivateMessage: "Choose a title for your Private Message",
  startToRecord: "Tap to Start Record",
  story: "Story",
  copyLinkToYourClipBoard: "Copy link to your clipboard and share ",
  linkCopy: "Link Copied",
  findGoodLight: `<span class="font-semibold">Find Good Lighting</span><span class="font-semibold">:</span><span class="font-medium"> Natural light or a well-lit room helps keep your video clear and warm. Avoid harsh backlighting.</span>`,
  verticalFraming: `<span class="font-semibold">Use Vertical Framing</span><span class="font-semibold">:</span><span class="font-medium"> Record in portrait mode so your video looks great on all devices. Keep yourself centered.</span>`,
  speakClearly: `<span class="font-semibold">Speak Clearly & Naturally</span><span class="font-semibold">:</span><span class="font-medium"> Talk at a steady pace and look at the camera as if speaking to your loved ones.</span>`,
  keepItSteady: `<span class="font-semibold">Keep It Steady</span><span class="font-semibold">:</span><span class="font-medium"> Hold your phone still or use a stand to avoid shaky footage for a more polished video.</span>`,
  letMeTry: "Let me try later",
  letMeTryAgain: "Let me try Again",
  iAmReady: "I'm ready to record my story",
  saveStory: "Save Story",
  whoWillReceiveMessage: "Who will receive this message?",
  privateMessageToolTip:
    "By selecting this checkbox, this message and the name of its recipient will be kept hidden from your account agent.  It will be released (sent to the recipient) when your agent releases other messages",
  storySuccessTitle: "Your story has been successfully added",
  privateMessageSuccessTitle:
    "Your private message has been successfully added",
  storyDeleteTitle: "Your story has been successfully Deleted",
  privateMessageDeleteTitle:
    "Your private message has been successfully Deleted",
  storyAddSubtitle: "Add more item for your Legacy",
  mayBeLater: "Maybe Later",
  shareInfo: `You can allow others to view all your stories by sharing the link below.  Your stories will be available at that link based on the "release timing" you've specified for each.  For example, stories that you've designed as having a release timing of "now" are available now.  If you have a life event, such as an incapacitation, your life stories with a release timing of "immediate upon incapacitation" will be added to the stories available at the same link.`,
};

export const circleLabels = {
  onBoardingProgressTitle: "Circle Onboarding progress",
  onBoardingProgressDescription:
    "Help us get to know you by answering a few questions.",
  onboardingCircle: "Onboarding Circle",
};

export const beneficiaryLabels = {
  deleteBeneficiary: "Delete", // Beneficiary",
  saveBeneficiary: "Save", // Beneficiary",
  spouse: "Spouse",
  personalInformation: "Personal Information",
  citizenship: "Citizenship",
  contactInformation: "Contact Information",
  addressInformation: "Address Information",
  medicalInformation: "Medical Information",
  veterinarian: "Veterinarian",
  generalnformation: "General Information",
  credentials: "Credentials",
  renterInformation: "Renter or Management Company",
  leaseContract: "Lease or Management Contract",
  children: "Children",
  sameAsUser: "Same address as the user?",
  successTitle: `<span class="font-medium">Your beneficiary has been</span> <span class="font-semibold">successfully added</span>`,
  updateSuccessTitle: `<span class="font-medium">Your beneficiary has been</span> <span class="font-semibold">successfully updated</span>`,
  deleteSuccessTitle: `<span class="font-medium">Your beneficiary has been</span> <span class="font-semibold">successfully deleted</span>`,
  successAssetTitle: `<span class="font-medium">Your asset has been</span> <span class="font-semibold">successfully added</span>`,
  updateSuccessAssetTitle: `<span class="font-medium">Your asset has been</span> <span class="font-semibold">successfully updated</span>`,
  deleteSuccessAssetTitle: `<span class="font-medium">Your asset has been</span> <span class="font-semibold">successfully deleted</span>`,
  successSubtitle: "You can come back and add more whenever you need",
};

export const assetsLabels = {
  onBoardingProgressTitle: "Asset Onboarding progress",
  letsAdd: "Let's add your",
  assetModule: "accounts, properties, and valuables",
  onePlace: "in one place",
  assetSubtitle:
    "To get started, we'd like to ask a few questions to learn more about you and your assets",
  deleteAsset: "Delete Asset",
  saveAsset: "Save Asset",
  editAsset: "Edit Asset",
  onboardingAssets: "Onboarding Assets",
  asset: "asset",
  save: "Save",
};

export const wishesLabel = {
  createPrincipleRecipientTitle:
    "Create a new <span class='font-[600]'> Principle Recipient </span>",
  create1stBackupRecipientTitle:
    "Create a new <span class='font-[600]'> 1st Backup Recipient </span>",
  create2ndBackupRecipientTitle:
    "Create a new <span class='font-[600]'> 2nd Backup Recipient </span>",
  onBoardingProgressTitle: "Wishes Onboarding progress",
  wishes: "Wishes",
  letsSetup: "Let's set up your",
  wishModule: "cash bequests, assets bequests, remainder distribution,",
  wishOtherModule: "disinheritance, trusts,",
  andMore: " and more",
  disinherit: "Disinherit",
  disinheritDescription: `In this section, you can  <span class="font-500 text-deepSky"> exclude individuals </span> from your inheritance.`,
  learnMoreAboutInherit: "Learn more about Disinherit",
  learnMoreAboutAssetBequestTooltip:
    "Asset bequests specify who should receive specific assets from your estate, such as pieces of jewelry, watches, or furniture.",
  cashBequest: "Cash Bequest",
  cashBequestDescription: `If you would like to leave specific cash amounts to individuals, organizations or pets, you can designate <span class="font-500 text-deepSky">beneficiaries</span> and specify the amount you want to leave them before your remaining estate is distributed.`,
  learnMoreAboutCashBequest: "Learn more about cash bequest",
  nonprofitsAndTrusts: "Non-profits and trusts",
  optional: "Optional",
  familyPetsCashBequest: "Family & Pets Cash Bequest",
  cashBequestToFamilyNPets: "Cash bequest to family and pets",
  familyPetsCashBequestDescription:
    "You can make specific cash bequests to family and pets.",
  learnMoreAboutFamilyPetsCashBequest:
    "Learn more about Family & Pets Cash bequest",
  details: "Details",
  pet: "Pet",
  totalBequested: "Total bequested",
  designateWhoShouldReceiveEachAsset: `Designate who should <span class="font-500 text-deepSky">receive each asset</span>.  You can select backup recipients as needed.`,
  learnMoreAboutBequestAssets: "Learn more about bequest assets",
  selectAsset: `For each <span class="font-[600]">asset</span>, you may <span class="font-[600]">choose a beneficiary </span> to receive it.`,
  selectPrincipalRecipient: `Select a person to be your <span class="font-[600] text-btnActive">Principal Recipient</span>`,
  select1stBackupRecipient: `Select a person to be your <span class="font-[600] text-btnActive">1st Backup Recipient</span>`,
  select2ndBackupRecipient: `Select a person to be your <span class="font-[600] text-btnActive">2nd Backup Recipient</span>`,
  chooseAnExisting: `Choose an existing <span class="font-[600] text-deepSky">beneficiary</span>`,
  selectRecipient: "Select Recipient",
  principalRecipient: "Principal Recipient",
  backupRecipient: "1st Backup Recipient",
  backupRecipient2: "2nd Backup Recipient",
  bequestAssets: "Bequest assets",
  remainderDistribution: "Remainder distribution",
  remainderDistributionDescription: `After all debts and bequests have been settled, indicate <span class='font-500 text-deepSky'>how you’d like to see your remaining estate be distributed</span>`,
  learnMoreAboutRemainderDistribution:
    "Learn more about Remainder distribution",
  tooltipContent:
    "Cash bequests are the amounts of money you want to give to specific individuals, non-profits, trusts, or other legal entities before the rest of your estate given away.",
  remainderDistributionTooltipDescription:
    "After all your specific bequests are given out and debts are paid, what’s left of your estate is the residual.",
  disinheritInfo:
    "To disinherit is to explicitly exclude members of your family from your estate upon your passing.",
  spousalTrustInfo:
    "When you pass away, this 'safe deposit box' holds assets that you want to eventually pass to your heirs, but with a layer of protection and specific conditions to support your spouse",
  dependentTrustInfo:
    "This trust, also known as a coming of age trust, holds back a percentage of inheritance until the beneficiary reaches specific ages.  For example, you may elect to give a child 10% of her inheritance at 21 years old, another 40% when she turns 25, and the remaining 50% when she turns 30",
  bodyHandlingInfo:
    "This section allows you to specify how you would like your body treated after you've passed, including burial or cremation, and final resting location",
  funeralPlanDirectionInfo:
    "This section allows you to give direction to your family and loved ones for your funeral plans",
  myResponsibilityAsAgent:
    "If you have been invited to act as an agent on behalf of a Lved.com user, you can manage your commitment here, including authentication, access to items they've made available in their digital vault",
  otherPerson: "Other Persons",
};

export const remainderDistributionLabels = {
  childrenPredeceaseYou:
    "In the event that two or more of your children predecease you, how would you like to distribute their shares to their children (Per Capita means every grandchild is given an equal share, Per Stirpes means each grandchild is given an equal share as their siblings)?",
  predeceaseInheritance: "Predecease inheritance",
  perCapita: "Per Capita",
  perStirpes: "Per Stirpes",
  loading: "Loading existing beneficiaries...",
  allocationReached:
    "Total allocation exceeds 100%. Please adjust the percentages.",
  warningMsg:
    "Please assign percentage ( % ) to save the recently added beneficiaries",
  residualEstateHeirs: "Residual estate heirs",
  distributeBelow:
    "Don't divide it equally among my children, I'll distribute it below.",
  alternateRemainingEstate:
    "How would you like to divide your alternate remaining estate?",
  alternateRemainderDistribution: "Alternate remainder distribution",
  noSpouseShouldBeThePrincipalRemainderBeneficiary:
    "No, my spouse shouldn't be the principal remainder beneficiary",
  yesSpouseShouldBeThePrincipalRemainderBeneficiary:
    "Yes, my spouse should be the principal remainder beneficiary",
  wouldYouLikeYourSpouseToBeYourPrincipalRemainderBeneficiary:
    "Would you like your spouse to be your principal remainder beneficiary?",
  principalRemainderDistribution: "Principal remainder distribution",
  remainderDistribution: "Remainder distribution",
};

export const documentLabels = {
  documents: "Documents",
  subtitle: "Generate, manage and add new documents",
  sucessSubtitle: "Your action has been completed successfully.",
  learnMore: "Learn more about Documents",
  pendingGeneration: "Pending Generation",
  documentGenerated: "Document Generated",
  documentUnableTitle: "Document not enabled to be generated",
  documentUnableSubtitle:
    "You must designate at least one account agent to act as power of attorney",
  maybeLater: "Maybe Later",
  specifyAgent: "Specify Account Agent",
  generatingDocument: "We're generating your legal document",
  generatedSuccessfully: "Your document has been successfully generated",
  errorGeneratingTitle: "Your document could not be generated.Please try again",
  generateMore: "Generate More Legal Document",
  outOfDate: "Out Of Date",
  viewDocument: "View Document",
  print: "Print",
  save: "Save",
  seeHistory: "See History",
  generateDoc: "Generate Document",
  generateDocToValidate:
    "Generate the legal documents needed to validate your estate plan",
  uploadSignedDoc: "Upload Signed Document",
  signDocWarning:
    "Before uploading the document, make sure you have signed the last page.",
  scanDoc: "Use your phone to scan document",
  scanDocInstruction: "Point your phone's camera to read this qr code",
  saveFile: "Save File",
  selectPrincipalGuardian: "Select your principal guardian",
  documentTooltipText:
    "This section holds your estate planning legal documents that are generated and updated based on your circle, assets, and wishes.",
  loadDocument: "Loading document...",
  errorDocument: "Error loading document:",
  personalDetailsRequired: "Personal Details Required",
  personalDetailsDesc: "Personal details missing. Please update to continue.",
  updatePersonalDetails: "Update Personal Details",
  uploadSignedDocument: "Upload signed document",
  documentLegalized: "Document Legalized",
  documentGenerating: "Document Generating",
  errorGenerating: "Error Generating Document",
  reGenerateDocument: "Re-Generate Document",
  retry: "Retry",
  history: "History",
  noHistoryFound: "No History Found",
  historyDec: "Document history will appear here once available.",
};
export const healthLabels = {
  addPrincipalHpoA: "Add Principal HPoA",
  addCoPrincipalHpoA: "Add Co-Principal HPoA",
  addBackupPrincipalHpoA: "Add Backup HPoA",
  selectPersonPrincipalHPoA: `Select a person to be your <span class='font-[600]'> Principal Health Power of Attorney </span>`,
  selectPersonCoPrincipalHPoA: `Select a person to be your <span class='font-[600]'> Co-Principal Health Power of Attorney </span>`,
  selectPersonBackupHPoA: `Select a person to be your <span class='font-[600]'> Backup Health Power of Attorney </span>`,
  chooseBeneficiary: `Choose an existing <span class='font-[600] text-deepSky'>beneficiary</span>`,
  sendRequestPersonPrincipalHpoA: `Send request to your <span class='font-[600]'> Principal Health Power of Attorney </span>`,
  sendRequestPersonCoPrincipalHpoA: `Send request to your <span class='font-[600]'> Co-Principal Health Power of Attorney </span>`,
  sendRequestPersonBackupHpoA: `Send request to your <span class='font-[600]'> Backup Health Power of Attorney </span>`,
  sendRequestPersonSubtitle: `You can <span class='font-[600] text-deepSky'> customize </span>your request for your chosen <span class='font-[600]'> health power of attorney </span>`,
  sendRequestPersonSubtitleHealthSupport: `You can <span class='font-[600] text-deepSky'> customize </span>your request for your chosen <span class='font-[600]'> health support </span>`,
  selectHPoA: "Select Health Power of Attorney",
  addedSuccessTitle: "Your request has been submitted successfully",
  addedSuccessSubtitle:
    "You will be notified when your power of attorney approves it",
  addedSuccessSubtitleHealthSupport:
    "You will be notified when your health support approves it",
  createPrincipleHPoATitle:
    "Create a new <span class='font-[600]'> Principle Health power of attorney </span>",
  createCoPrincipleHPoATitle:
    "Create a new <span class='font-[600]'> Co-Principle Health power of attorney </span>",
  createBackupHPoATitle:
    "Create a new <span class='font-[600]'> Backup Health power of attorney </span>",
  grantAccess: "Grant Access",
  healthSupportLabel: `Select a person to be given access to your<span class='font-[600]'> Medical Information </span>`,
  selectPerson: "Select Person",
  financialPOATooltip:
    "Who you designate as your Financial Power of Attorney becomes your fiduciary and can handle your finances, possibly making decisions about investments, paying bills, and taking care of other monetary obligations.",
  addPrincipalFpoA: "Add Principal FPoA",
  addCoPrincipalFpoA: "Add Co-Principal FPoA",
  addBackupPrincipalFpoA: "Add Backup FPoA",
  selectPersonPrincipalFPoA: `Select a person to be your <span class='font-[600]'> Principal Financial Power of Attorney </span>`,
  selectPersonCoPrincipalFPoA: `Select a person to be your <span class='font-[600]'> Co-Principal Financial Power of Attorney </span>`,
  selectPersonBackupFPoA: `Select a person to be your <span class='font-[600]'> Backup Financial Power of Attorney </span>`,
  sendRequestPersonPrincipalFpoA: `Send request to your <span class='font-[600]'> Principal Financial Power of Attorney </span>`,
  sendRequestPersonCoPrincipalFpoA: `Send request to your <span class='font-[600]'> Co-Principal Financial Power of Attorney </span>`,
  sendRequestPersonBackupFpoA: `Send request to your <span class='font-[600]'> Backup Financial Power of Attorney </span>`,
  selectFPoA: "Select Financial Power of Attorney",
  addedSuccessSubtitleFPoA:
    "You will be notified when your Financial of attorney approves it",
  createPrincipleFPoATitle:
    "Create a new <span class='font-[600]'> Principle Financial power of attorney </span>",
  createCoPrincipleFPoATitle:
    "Create a new <span class='font-[600]'> Co-Principle Financial power of attorney </span>",
  createBackupFPoATitle:
    "Create a new <span class='font-[600]'> Backup Financial power of attorney </span>",
  powerOfAttorney: "Powers of attorney",
  details: "Details",
  selectAllOptions: "Select All Options",
};

export const estatePlanCards = [
  {
    title: "Circle",
    desc: "Manage and register all your loved ones around you",
    backgroundSvg: estatePlanCircle,
    icon: estateCircle,
    buttonLink: ROUTE_PATHS.ESTATE_PLAN_CIRCLE,
  },
  {
    title: "Assets",
    desc: "Customize your legacy and assets",
    backgroundSvg: estatePlanAssetBg,
    backgroundDollarSvg: estatePlanAssetDollarBg,
    icon: estateAsset,
    buttonLink: ROUTE_PATHS.ESTATE_PLAN_ASSET,
  },
  {
    title: "Wishes",
    desc: "Set your preferences for when the time comes",
    backgroundSvg: estatePlanWishes,
    icon: estateWishes,
    buttonLink: ROUTE_PATHS.ESTATE_PLAN_WISHES,
  },
  {
    title: "Plan Document",
    desc: "Generate your legal documents for your plan",
    backgroundSvg: estatePlanDoc,
    icon: estateDoc,
    buttonLink: ROUTE_PATHS.PLAN_DOCUMENTS,
  },
];
export const cards = [
  {
    title: "Circle",
    svg: circleSvg,
    desc: "Manage and register all your loved ones around you",
    img: circleVideo,
    subtitle: "Building my Estate Plan",
    backgroundSvg: circleBackgroundSvg,
  },
  {
    title: "Assets",
    svg: estateAsset,
    desc: "Manage and register all your loved ones around you",
    img: assetVideo,
    backgroundSvg: AssetSvg,
  },
  {
    title: "Wishes",
    svg: estateWishes,
    desc: "Set your preferences for when the time comes",
    img: wishesVideo,
    backgroundSvg: WishesSvg,
  },
  {
    title: "Documentation",
    svg: estateDoc,
    desc: "Generate your legal documents for your plan",
    img: documentVideo,
    backgroundSvg: DocumentSvg,
  },
];

// Function to get training object with i18n support
export const getTrainingData = (t) => [
  {
    title: t('training.1.title'),
    subtitle: t('training.1.subtitle'),
    shortDescription: t('training.1.shortDescription'),
    svg: circleSvg,
    img: circleVideo,
    backgroundSvg: circleBackgroundSvg,
  },
  {
    title: t('training.2.title'),
    subtitle: t('training.2.subtitle'),
    shortDescription: t('training.2.shortDescription'),
    svg: estateAsset,
    img: assetVideo,
    backgroundSvg: AssetSvg,
  },
  {
    title: t('training.3.title'),
    subtitle: t('training.3.subtitle'),
    shortDescription: t('training.3.shortDescription'),
    svg: estateWishes,
    img: wishesVideo,
    backgroundSvg: WishesSvg,
  },
  {
    title: t('training.4.title'),
    subtitle: t('training.4.subtitle'),
    shortDescription: t('training.4.shortDescription'),
    svg: estateDoc,
    img: documentVideo,
    backgroundSvg: DocumentSvg,
  },
];

export const dashboardCards = [
  {
    title: "Circle",
    icon: dashboardCircle,
    notification: {
      text: "New Children Added",
    },
  },
  {
    title: "Assets",
    bgIcon: dashboardBgAsset,
    icon: dashboardAsset,
    notification: {
      text: "New Children Added",
    },
  },
  {
    title: "Wishes",
    icon: dashboardWishes,
    notification: {
      text: "New Children Added",
    },
  },
];

/*export const dashboardSections = [
  {
    header: "My Estate Plan",
    svgIcon: estatePlan,
    title: "We help you to build your estate plan",
    highlight: "step-by-step",
    subtitle: "Meet the steps on side →",
    buttonName: "choosePlan",
    buttonText: "Start your Plan",
    description: "Set all your preferences for when you pass away",
    details:
      "Manage your circle, define your assets, set your wishes and much more.",
    imagePath: "estate-plan.jpg",
    buttonLink: ROUTE_PATHS.MY_ESTATE_PLAN,
  },
  {
    header: "Digital Vault",
    svgIcon: digitalVault,
    title: "Keep all your things ",
    highlight: "safe",
    restTitle: "and",
    restHighlight: "easily access",
    subtitle: "Create groups and items to save",
    buttonName: "storeNewItem",
    buttonText: "Store new item",
    description: "Save your things, forever",
    details: "Create collections, storage and keep all totally safe.",
    imagePath: "digital-valut.png",
    buttonLink: ROUTE_PATHS.DIGITAL_VAULT,
  },
  {
    header: "My Legacy",
    svgIcon: legacy({ width: "24", height: "24" }),
    title: "Your ",
    highlight: "memories",
    restTitle: "and",
    restHighlight: "stories",
    restTitle1: "at same place",
    subtitle: "Record and share video messages",
    buttonName: "createNewMessage",
    buttonText: "Create a New Message",
    description: "Create stories and memories for later",
    details: "Manage, share and watch good memories for your life.",
    imagePath: "legacy.jpg",
    buttonLink: ROUTE_PATHS.LEGACY,
  },
  {
    header: "Documents",
    svgIcon: document,
    title: "Organize your essential",
    highlight: "documents",
    subtitle: "Secure store and access your papers",
    buttonName: "addNewDocument",
    buttonText: "Add New Document",
    description: "Manage all your documents in one place",
    details: "Your activities will be displayed here",
    imagePath: "document.png",
  },
];*/

export const footerResponse = [
  {
    title: "You need to create your passphrase",
    subtitle: "Create a passphrase",
    moduleKey: "SECURITY",
  },
  {
    title: "Keep your data safe on Digital Vault",
    subtitle: "Go to Digital Vault",
    moduleKey: "DIGITAL_VAULT",
  },
  {
    title: "Choose who will be your account agent",
    subtitle: "Go to account agent",
    moduleKey: "ACCOUNT_AGENT",
  },
  {
    title: "Leave videos and messages for later",
    subtitle: "Go to Legacy",
    moduleKey: "LEGACY",
  },
  {
    title: "Get your Estate Plan plus a year of LVED's Plan",
    subtitle: "Our plans",
    moduleKey: "MY_ESTATE_PLAN",
  },
];

export const ROLES_MODULE = {
  INFO_TOOLTIP:
    "If you have been invited to act as an agent on behalf of a Lved.com user, you can manage your commitment here, including authentication, access to items they've made available in their digital vault",
  ROLE_DESCRIPTION: "You are a {role} of this Estate Plan. Perform actions on behalf of Plan's Owner.",
  MODULE_HEADING: "Roles, Requests and Responsibilities",
  MODULE_TITLE: "Roles",
  MODULE_TABS: {
    AGENT_TAB: {
      TAB_TITLE: "My Responsibilities as Agent",
      CHOOSE_PLAN_TEXT: `Tap to Choose a Plan to <span class='font-[600]'> Manage</span>:`,
      PLAN_TEXT: `Plans that you are <span class='font-[600] text-deepSky'> Agent</span>:`,
      TAB_DETAIL_TITLE: "Account agent responsibilities",
      TAB_DETAIL_SUBTITLE: `Some actions can only be performed when the plan's owner is <span class='font-[600]'> incapacitated </span> or has  <span class='font-[600]'> passed away</span>`,
      TAP_OPTIONS: "Tap on the options below to execute",
    },
    ROLES_TAB: {
      TAB_TITLE: "Other Roles",
      LBL_CHILDREN_GUARDIAN: "Children Guardian",
      LBL_TRUSTEE: "Trustee",
    },
    REQUEST_TAB: {
      TAB_TITLE: "Requests",
      BTN_GO_TO_MY_ROLES: "Go to My Roles",
      BTN_OPEN_REQUEST: "Open Request",
      BTN_GO_TO_ROLE: "Go to Roles",
      LBL_NEW_REQUEST: "New Request",
      LBL_NO_REQUEST: "No requests found.",
      LBL_CHOOSE_ONE_BELOW:
        "Choose one below by clicking or just drag and drop here",
    },
  },
  MODULE_DIALOGS: {
    DOCUMENTS: {
      TITLE: (role) =>
        `Shared Documents for Your Role as <span class='font-[600] text-deepSky'> ${role} </span>`,
      DETAILS: (name) =>
        `View and access the legal documents entrusted to you by ${name}`,
      VIEW_DOCUMENTS: "View documents",
    },
    CONFIRM_RELEASE: {
      TITLE: (name) => `Are you sure you want to release ${name}'s items?`,
      DETAILS: (name) => `
        The items in ${name}'s in digital vault will be shared with their designated recipients.`,
      BTN_CANCEL: "Cancel",
      BTN_RELEASE_ITEMS: "Release Items",
    },
    CONFIRM_DEATH: {
      TITLE: (name) => `Are you sure you want to register ${name}'s death?`,
      DETAILS: (name) => `
        You are about to register the passing of ${name}.
        This action will impact the estate plan. Please ensure all information is accurate before proceeding.`,
    },
    CONFIRM_INCAPACITY: {
      TITLE: (name) =>
        `Are you sure you want to register ${name}'s incapacity?`,
      DETAILS: (name) => `
        This action will trigger notifications to ${name}
        and their circle and can only be undone by ${name} upon their next login`,
    },
    RELEASE_MESSAGES: {
      TITLE: (name) =>
        `Are you sure to release <span class='font-[600]'> all private messages </span>
        from <span class='font-[600]'> ${name} </span>
        's Plan?`,
      DETAILS: "Once messages are released, it can not be undo.",
      DETAILS_PENDING_MESSAGES: "There are 3 messages waiting",
      BTN_RELEASE_NOW: "Release Now",
    },
    RELEASING_MESSAGES: {
      TITLE: (name) =>
        `We're releasing <span class='font-[600]'>${name}'s </span> Private Messages`,
    },
    CONFIRM_REPUDIATE: {
      TITLE: "Are you sure you want to repudiate this role?",
      DESCRIPTION:
        "You will lose all actions of an account agent. This action cannot be undone.",
      BTN_CONFIRM: "Confirm repudiation",
      BTN_CANCEL: "Cancel repudiation",
    },
    CONFIRM_DISPUTE: {
      TITLE: "Access Restricted",
      DESCRIPTION:
        "Your profile status is currently set to “Incapacitated”, so you cannot access the system. To regain access, please click the “Alive and Well” button to update your status and continue.",
      BTN_CONFIRM: "Alive & Well",
      BTN_CANCEL: "Cancel",
    },
    REQUEST_ATTENTION: {
      TITLE: "We need your attention to this request",
      DETAILS: [],
      BTN_ACCEPT: "Accept Request",
      BTN_DECLINE: "Decline",
      LBL_PENDING_REQUEST: "Pending requests for you to be an ",
      LBL_WANT_TO_BE: "Do you want to be my ",
    },
    SHARE_STORIES: {
      TITLE: "Copy link to your clipboard and share",
      INVALIDATE_LINK: "Invalidate Link",
      DETAILS: (name) =>
        `This link contains <span class='font-[600] text-deepSky'> all the stories </span> <span class='font-[600]'> ${name} </span> posted on LVED. Share with care.`,
      LBL_LINK_COPIED: "Link Copied",
    },
    SUCCESS: {
      TITLE:
        "Items have been <span class='font-[600]'> successfully released </span>",
      DETAILS: "All recipients received their items",
    },
    UNRELEASED_MESSAGES: {
      MESSAGE_NOT_RELEASED: "1 Message(s) have not been released",
      TITLE: "Update Contact Info",
      DETAILS: [
        `This is typically due to a <span class='font-[600]'> cooling off period </span>
         or a 
        <span class='font-[600]'> desire </span>
        to withhold these messages until after a death certificate has been obtained.`,
      ],
      BTN_IGNORE: "Ignore This Message",
      BTN_UPDATE: "Update and Share Again",
      BTN_GOT_IT: "Got it",
      BTN_LATER: "Maybe later",
      BTN_UPDATE_CONTACT_INFO: "Update Contact Info",
      LBL_RECIPIENT: "Recipient",
      LBL_MESSAGE_NOT_SEEN: "The recipient has not seen the message via email.",
      LBL_MESSAGE_RECIEVED:
        "The recipient received the message! No action needed.",
      LBL_MESSAGE_REPLIED:
        "The recipient has the recipient of this message replied:",
      LBL_RECIPIENT_DECLINED_MESSAGE:
        "The recipient has declined this message:",
      LBL_WRONG_NUMBER: "Wrong number, try this one:",
    },
  },
  BTN_YES: "Yes",
  BTN_CANCEL: "Cancel",
  BTN_CONTINUE: "Continue",
  BTN_UPLOAD_DEATH_CERT: " Upload death certificate ",
  BTN_CORRECT_REG_INCAPACITATED: " Correct registration to incapacitated",
  BTN_REPUDIATE_ROLE: "Repudiate this Role",
  LBL_AUTHENTICATED: "Authenticated",
  LBL_RELEASE_ITEMS: "Release Items",
  LBL_LEGAL_DOCS: "Legal Documents",
  LBL_SHARE_STORIES: "Share Stories",
  LBL_RELEASE_PVT_MESSAGES: "Release Private Messages",
  LBL_REGISTER_INCAPACITY: "Register Incapacity",
  LBL_REGISTER_DEATH: "Register Death",
  LBL_ESTATE_PLAN_CREATOR: "Estate Plan Creator",
  LBL_NO_HISTORY: "No history yet",
  LBL_ACCOUNT_HISTORY: "Account History",
  LBL_ACTION_HISTORY: "Action History",
  LBL_NO_PLAN: "Plan not found",
  LBL_NEW: "New",
  LBL_OLDER: "Older",
  LBL_MESSAGE: "Message: ",
  LBL_FROM: "From: ",
  ACCOUNT_STATUS: {
    LABEL: "Account Status",
    VALUE: {
      ALIVE_AND_WELL: "Alive and Well",
      PASSED_AWAY: "Passed Away",
      INCAPACITATED: "Incapacitated",
    },
  },
};

export const securityModule = {
  securityTitle:
    "Security module loaded. Manage your encryption passphrase and view encrypted data statistics.",
  passphraseLabel: "Passphrase",
  moduleHeading: "Security", // NOSONAR - UI message, not a credential
  moduleTitle: "Security",
  moduleDescription: "Manage your encryption keys",
  moduleCards: {
    createPassphrase: {
      title: "You need to create your passphrase",
      subtitle: "Protect your data with an encrypted passphrase",
      btnCreate: "Create my Passphrase",
    },
    passphraseCreated: {
      title: "Your Private Key is in a Good Shape!",
      status: "Passphrase created",
      description:
        "If you lose your passphrase, access to your encrypted data may be permanently lost.\nKeep it safe and never share it with anyone. You can change your passphrase at any time.",
      btnChange: "Change Passphrase",
      synchronized: "Synchronized",
      description2:
        "If you feel your private key has been compromised, you may generate a new key.", // NOSONAR - UI message, not a credential
      note: "Note: changing your private key means you will need to go through the authentication process with anyone you are serving as account agent. You will also need to re-authenticate your account agents before you can rotate your encryption key",
    },
  },
  usageBar: {
    title: "Encrypted Storage Data",
    defaultLabel: "Encrypted Files",
  },
  dialog: {
    loseMyDataBtn: "Lose my encrypted data",
    loseDataPassphraseTitle: "Enter phrase here",
    loseDataTitle: "Lose encrypted data",
    loseDataWarning: "Encrypted data will be lost",
    loseDataSubtitle:
      "If you proceed, all your encrypted data will be permanently erased. Please note that changing your private key will necessitate re-authenticating all your agents. You’ll be lost:",
    loseDataConfirm: `To confirm this, type <span class='font-[500]'>“Lose my encrypted data”</span>`,
    loseDataBtn: "Lose my encrypted data",
    loseDataSize: (size) => `${size} of data`,
    loseDataReAuth: (count) => `Re-authenticate ${count} agent(s)`,
    wrongPassphraseTitle: "Wrong passphrase",
    wrongPassphraseSubtitle:
      "Unfortunately, your passphrase isn’t right. You can try again or create a new one that will erase your encrypted data.", // NOSONAR - UI message, not a credential
    loseAllDataBtn: "Lose all encrypted data",
    confirmPassphraseTitle: "Confirm your passphrase",
    confirmPassphraseSubtitle:
      "You’re using a new device, please enter or restore your key to continue using the app", // NOSONAR - UI message, not a credential
    restoreMyKeyBtn: "Restore my key",
    enterMyKeyBtn: "Enter my key",
    restorePassphraseTitle: "Restore your passphrase",
    currentPassphraseLabel: "Enter your current passphrase",
    restorePassphraseSubtitle:
      "To change your passphrase we need to decrypt your data using your old passphrase and encrypt it again with the new one. It may take some time to get done, are you sure you want to continue?", // NOSONAR - UI message, not a credential
    checkingPassphrase: "Checking your passphrase",
    restorePassphrase: "Restore passphrase", // NOSONAR - UI message, not a credential
    submitPassphraseTitle: "Enter your passphrase", // NOSONAR javascript:S2068 - UI message label, not a credential
    submitPassphraseShowHintBtn: "Show hint", // NOSONAR javascript:S2068 - UI message label, not a credential
    submitPassphraseSubtitle:
      "To proceed, please enter your <span class='font-[500] text-deepSky'> passphrase</span>.", // NOSONAR - UI message, not a credential
    submitPassphraseDescription:
      "If you need help remembering it, you can view a hint.", // NOSONAR javascript:S2068 - UI message label, not a credential
    passphraseCreatedSuccessTitle:
      "Your passphrase has been successfully created",
    passphraseCreatedSuccessSubtitle:
      "Keep it safe. Your passphrase is essential for your account security.", // NOSONAR javascript:S2068 - UI message label, not a credential
    passphraseRestoredSuccessTitle:
      "Your passphrase has been successfully restored",
    title: "Create your passphrase",
    heading: `Create a <span class='font-[500] text-deepSky'> secure </span> passphrase to protect your account`,
    description: `Passphrases are case-sensitive, and punctuation is ignored. Avoid common words, such as your name or anything related to the app, and do not repeat words in your passphrase.`,
    hint: "Minimum 8 words.",
    placeholder: "Create a secure passphrase",
    next: "Next Step",
    msgMinWords: "Minimum 8 words.",
    msgLowSecurity: "Your passphrase security level is low.",
    hintStep: {
      title: `Add a <span class='font-[500] text-deepSky'> hint </span> to help you remember your passphrase`,
      description:
        "Save an optional and structured hint to recall your actual passphrase. Choose something meaningful only to you.",
      placeholder: "Passphrase Hint",
      warning:
        "You can't recover the passphrase if you lose it, so add a good quality hint.",
      back: "Back",
      submit: "Next Step",
      errorInvalid:
        "Invalid: Do NOT include your passphrase, personal information or device references.",
      success:
        "I want to leave it empty so it's not easily guessable by others.",
      hintValid:
        "Valid hint. Ensure it’s meaningful to you and not easily guessed by others.",
      hintValidInfo:
        "Ensure it’s meaningful to you and not easily guessed by others.",
      hintLengthValid: "Minimum 8 characters.",
      hintInvalid:
        "Invalid hint. Do not include your passphrase, personal information, or obvious references.",
      passphraseInvalid: "Avoid common words, personal info or patterns.", // NOSONAR javascript:S2068 - UI message label, not a credential
    },
    reviewStep: {
      label: "Label",
      title: `<span class='font-[500] text-deepSky'> Review </span> your information before continuing`,
      description:
        "Make sure your passphrase is correct and securely stored! If you’ve added a hint, confirm that it’s helpful to you and not easily guessable by others.",
      back: "Back",
      submit: "Create Passphrase",
      encrypting: "Encrypting your passphrase",
    },
  },
};

export const otherForms = {
  OTHER_PERSON: 47,
  PET: 1,
  CHILD: 21,
  SPOUSE: 22,
  NON_PROFIT: 29,
  OTHER: 26,
  OTHER_BENEFICIARY: 26,
  OTHER_CONTACT: 46,
  CIRCLE_ONBOARDING: 10,
  ASSET_ONBOARDING: 16,
  WISHES_ONBOARDING: 36,
};

export const screenReaderText = {
  keyUpDownText: "Use arrow keys to change age, or click to open dropdown",
  principalRemainderDistributionOptions:
    "Principal remainder distribution options",
};

export const homeLabels = {
  apiResponseTest: "CustomFormField API Response Test",
  category: "Category: ",
  formData: "Form Data:",
  option1: "Option 1",
  option2: "Option 2",
  option3: "Option 3",
  fillRequiredFields: "Please fill in all required fields.",
  formSubmittedSuccess: "form submitted successfully!",
};